$('body').on('click', '.open-sent-email-menu', function() {
    var $this = $(this);
    var menu = $this.parents('.sent-email-menu-wrapper');
    
    $('.sent-email-menu', menu).css({
        top: menu.position().top,
        left: 5 + (menu.position().left + menu.width()) - $('.sent-email-menu', menu).width()
    });

    menu.addClass('opened');
    closeDropdown($this.parents('.sent-email-menu-wrapper').attr('data-dropdown'));
    return false;
});

$('body').on('click', '.resend-sent-email-trigger', function() {
    var data = $(this).parents('.sent-email');
    var action = $('.resend-sent-email form').attr('data-action').replace('{sent_email}', data.attr('data-sent_email'));
    $('.resend-sent-email form').attr('action', action);
    $('.resend-sent-email [name="email"]').val(data.attr('data-email'));
    closeDropdown();
    openModal('.resend-sent-email');
    return false;
});

$('body').on('submit', '.resend-sent-email form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});

channel.bind('process-sent-email', function(data) {
    console.log(data);

    var element;
    if($('.sent-emails [data-sent_email="'+data.sent_email+'"]').length) {
        
        element = $('.sent-emails [data-sent_email="'+data.sent_email+'"]');
        element.attr('data-email', data.email);

        element.find('[data-input="from_name"]').html(data.from_name);
        element.find('[data-input="from_email"]').html(data.from_email);
        element.find('[data-input="email"]').html(data.email);
        element.find('[data-input="subject"]').html(data.subject);
        element.find('[data-input="attachments_count"]').html(data.attachments_count);
        element.find('[data-input="total_opened"]').html(data.total_opened);
        element.find('[data-input="status"]').html(data.status);
        element.find('[data-input="status"]').attr('data-color', data.status_color);
        element.find('[data-input="date_added"]').html(data.date_added);
        
        element.find('.sent-email-menu').html(buttons(data.buttons));
        return;
    }

    if ($('body').attr('data-page') === '1' && $('body').attr('data-summer') === data.summer) {
        element = $('<tr>', {
            class: 'sent-email',
            'data-sent_email': data.sent_email,
            'data-email': data.email
        });

        element.append(`<td>
            <p data-input="from_name">${data.from_name}</p>
            <p class="small-text" data-input="from_email">${data.from_email}</p>
        </td>

        <td data-input="email">${data.email}</td>

        <td data-input="subject">${data.subject}</td>
        <td data-input="attachments_count">${data.attachments_count}</td>
        <td data-input="total_opened">${data.total_opened}</td>
        
        
        <td><span class="highlight" data-input="status" data-color="${data.status_color}">${data.status}</span></td>
        <td>
            <p data-input="date_added">${data.date_added}</p>
        </td>
		<td class="sent-email-menu-wrapper menu-wrapper" data-dropdown="sent-email-${data.sent_email}">
            <a href="" class="icon-more open-sent-email-menu open-menu"></a>
            <ul class="sent-email-menu menu">
                ${buttons(data.element)}
            </ul>
        </td>`);


        $('.sent-emails tbody').prepend(element);
    }
});

channel.bind('remove-sent-email', function(data) {
    if($('.sent-emails [data-sent_email="'+data.sent_email+'"]').length) {
        $('.sent-emails [data-sent_email="'+data.sent_email+'"]').remove();
    }
});